<script setup lang="ts">
import { computed } from 'vue'
import EstablishmentCard from './EstablishmentCard.vue'
import type { MarketplaceEstablishment } from '@/http/models/MarketplaceEstablishment'
import type { Establishment as MarketingPageEstablishment } from '@/http/models/MarketingPage'
import EstablishmentCardLoading from './LoadingEstablishmentCard.vue'

type Props = {
  items: (MarketplaceEstablishment | MarketingPageEstablishment)[] | null
  placeholders?: number
}

const props = withDefaults(defineProps<Props>(), {
  placeholders: 20,
})

const loading = computed(() => props.items === null)
</script>

<template>
  <div class="offering-grid">
    <template v-if="loading">
      <EstablishmentCardLoading v-for="index in placeholders"
                                :key="`placeholder-${index}`"
                                data-test-id="establishment-card-placeholder"/>
    </template>
    <template v-else>
      <EstablishmentCard v-for="establishment in items"
                         :key="establishment.id"
                         :establishment="establishment"
                         data-test-id="establishment-card"/>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/css/mixins/breakpoints-up.scss";

@mixin flex-columns {
  display: flex;
  flex-direction: column;
  gap:     1rem;
}

@mixin grid($amount, $gap: 2rem) {
  display: inline-grid;
  grid-template-columns: repeat($amount, calc(100% / $amount - $gap + $gap / $amount));
  gap:     $gap;
}

.offering-grid {
  width: 100%;
  @include flex-columns;

  @include md-up {
    @include grid(2, 1rem);
  }

  @include lg-up {
    @include flex-columns;
  }

  @include xl-up {
    @include grid(2, 1rem);
  }

  @media(min-width: 1550px) {
    @include grid(3);
  }

  @include xxxl-up {
    @include grid(4);
  }
}
</style>
